import React, { useState } from 'react'
import { currencyFullValue } from '../../core/helpers'
import { ArrowDown, ArrowUp } from '../Icon'

import CardHead from '../Card/CardHead'
import Table from '../Table/Table'
import Card from '../Card/Card'

function CoinMarkets({ className, markets }) {
  const [isFull, showFull] = useState(false)
  const tickers = isFull ? markets : markets.slice(0, 5)

  if (!tickers.length) {
    return null
  }

  return (
    <Card className={className}>
      <CardHead title="Markets" action={
        markets.length > 5 && <div className="flex items-center text-grey cursor-pointer" onClick={() => showFull(!isFull)}>
          {isFull ? <ArrowUp /> : <ArrowDown />}
        </div>
      } />
      <Table>
        <thead>
        <tr className="text-sm text-grey">
          <td className="pb-2 pt-2 pr-0">#</td>
          <td className="pb-2 pt-2">Source</td>
          <td className="pb-2 pt-2">Pairs</td>
          <td className="text-right pb-2 pt-2">Price</td>
          <td className="text-right pb-2 pt-2">Volume</td>
        </tr>
        </thead>
        <tbody>
        {tickers.map((data, index) => (
          <tr key={index}>
            <td className="text-sm pr-0">{index + 1}</td>
            <td>
              <div className="flex">
                {data.name}
              </div>
            </td>
            <td>{data.pair}</td>
            <td className="text-right">{currencyFullValue(data.price)}</td>
            <td className="text-right">{currencyFullValue(data.volume)}</td>
          </tr>
        ))}
        </tbody>
      </Table>
    </Card>
  )
}

export default CoinMarkets
